import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Results() {
  const items = ['Entrás a cada búsqueda con más claridad.', 'Filtrás CVs con criterios concretos.', 'Entrevistás con estructura, no por intuición.', 'Presentás candidatos con más criterio profesional.', 'Seguís cada búsqueda hasta el cierre sin perder información.'];
  return <section className="py-24 bg-emerald-50" data-id="element-114">
      <div className="max-w-4xl mx-auto px-6" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-116">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-emerald-950" data-id="element-117">
            EL RESULTADO:
          </h2>
        </motion.div>

        <div className="bg-white rounded-3xl p-8 md:p-12 border border-emerald-100 shadow-xl shadow-emerald-900/5" data-id="element-118">
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-119">
            {items.map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: 10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className="flex items-start gap-4" data-id="element-120">
                <div className="mt-1 flex-shrink-0" data-id="element-121">
                  <ArrowRight className="w-5 h-5 text-emerald-500" data-id="element-122" />
                </div>
                <p className="text-slate-800 font-medium leading-relaxed" data-id="element-123">
                  {item}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}